import { render, staticRenderFns } from "./healthAmbassador.vue?vue&type=template&id=1693b84f&"
import script from "./healthAmbassador.vue?vue&type=script&lang=js&"
export * from "./healthAmbassador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports